export * from './Granted';
import granted from './Granted';
export default granted;